module.exports = __webpack_public_path__ + "img/LT.489b9983.svg";